import Image from 'next/legacy/image';
import { saveSessionRedirect } from 'utils/services';
import { SocialButtonProps } from 'types';

import cx from 'classnames';
import styles from './SocialButton.module.scss';

export const SocialButton = ({ logo, caption, onClick, hideCaptionOnMobile, mode, redirect }: SocialButtonProps) => {
  const { path = '', width, height } = logo || {};

  const handleSocialButtonClick = () => {
    if (redirect) {
      saveSessionRedirect(redirect);
    }
    onClick && onClick();
  };

  return (
    <div className={cx(styles.container, styles[`${mode}`])} onClick={handleSocialButtonClick}>
      <Image src={path} width={width} height={height} alt={caption} />
      <p className={cx({ [styles.toggleable]: hideCaptionOnMobile })}>{caption}</p>
    </div>
  );
};
